<template>
    <div class="standard sidebar">
        <div class="ui secondary vertical menu"
            data-step="1"
            data-position='right'
            data-intro="<br> 歡迎使用Neuron物流系統 <br> 選擇功能 開始編輯">
            <nav>
                <router-link v-if="$store.state.initialize_statuses.service_theme" :to="{name: 'provider_index'}">
                    <img class="ui image"
                        :src="'/images/'+service_config.logo_img">
                </router-link>
                <div v-else class="ui inverted dimmer transition active">
                    <div class="ui tiny text loader">
                        {{ $t('ui.general.initializing') }}
                    </div>
                </div>

                <a class="hamburger hamburger--spin"
                    @click="toggle_menu()">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </a>
            </nav>

            <div class="nav-menu">
                <SidebarItem
                    v-for="service_config_menu in $store.state.provider.service_config.menu"
                    :service_config_menu="service_config_menu"
                    :key="service_config_menu.name"
                    >
                </SidebarItem>

                <!-- <hr> -->

                <!-- <div v-for="menu in menus" :key="menu.name">

                    <router-link class="item"
                        v-if="!menu.items"
                        :to="{name: $store.state.initialize_statuses.sidebar ? menu.name:null}">
                        <i class="icons">
                            <i v-if="menu.icon" :class="menu.icon+' icon'"></i>
                            <span> {{ $t('ui.links.menu.'+menu.name) }} </span>
                        </i>
                    </router-link>

                </div>
                <router-link class="item" :to="{name: 'provider_demo'}" v-if="env == 'development'">
                    <i class="icons">
                        <i class="help icon"></i>
                        <span>Demo</span>
                    </i>
                </router-link> -->
            </div>

        </div>
    </div>
</template>

<script>
import SidebarItem from '@partials/provider/sidebar_item.vue'

export default {
    data() {
        return {
            menus: this.diff_service_config_menu(),
            is_show_mobile_menu: false,
        }
    },
    computed: {
        service_config() {
            return this.$store.state.provider.service_config
        },
        env() {
            return ENV.NODE_ENV
        },
    },
    watch: {
        '$route'(to, from) {
            if (
                (767 > $(window).width()) &&
                ($(".nav-menu").css("display") == "block")
            ) {
                this.toggle_menu()
            }
        },
    },
    mounted() {
        $(window).resize(() => {
            var wdth = $(window).width()
            var nav_menu_display = $(".nav-menu").css("display")
            if (nav_menu_display == 'none' && wdth > 767) {
                $(".nav-menu").css("display", "block")
            }
        })
    },
    methods: {
        diff_service_config_menu() {
            var service_config_menu = $.extend(true, [], this.$store.state.provider.service_config.menu)
            var result

            _.forEach(service_config_menu, (config_menu, index) => {
                result = _.findIndex(this.$store.state.provider.theme_menu, (menu) => {
                    return config_menu.name == menu
                })


                if (result < 0 && config_menu.items == undefined) {
                    delete service_config_menu[index]
                }


                // 還有子項目
                if (config_menu.items != undefined) {
                    _.forEach(config_menu.items, (item, item_index) => {
                        result = _.findIndex(this.$store.state.provider.theme_menu, (menu) => {
                            return item.name == menu
                        })

                        if (result < 0) {
                            delete service_config_menu[index].items[item_index]
                        }
                    })
                    _.remove(service_config_menu[index].items, _.isUndefined)

                }
            })

            // 整理子項目
            _.remove(service_config_menu, _.isUndefined)
            _.forEach(service_config_menu, (config_menu, index) => {
                var length = (config_menu.items) ? config_menu.items.length : 1
                if (!length) {
                    delete service_config_menu[index];
                }
            })
            _.remove(service_config_menu, _.isUndefined)

            return service_config_menu
        },
        toggle_menu() {
            $("body").toggleClass("overflow")
            $(".hamburger").toggleClass("active")
            $(".nav-menu").stop().slideToggle(300)
            this.is_show_mobile_menu = !this.is_show_mobile_menu
            this.$bus.$emit('toggle_is_hide_icon_toggle_scanner_modal', this.is_show_mobile_menu)
        },
    },
    components: {
        SidebarItem,
    },
}
</script>


<style lang="scss">
    @import "../../../assets/stylesheets/sidebar.scss";
</style>
